import React, { useEffect, useState, memo } from "react";
import {
  Container,
  Grid,
  makeStyles,
  Button,
  Typography,
  CardHeader,
  CardContent,
  Box,
  Card,
  Divider,
  Menu,
  IconButton,
  Tooltip,
  CardActions,
  Collapse,
} from "@material-ui/core";
import red from "@material-ui/core/colors/red";
import Page from "components/Page";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import { ModalFormulario, ModalGeneral, ModalPrint } from "components";
import { useForm } from "react-hook-form";
import getErrorMessage from "utils/getErrorMessage";
import Propuesta from "./Propuesta";
import serviciosCatalogo from "utils/serviciosCatalogo";
import { Scrollbars } from "react-custom-scrollbars";
import {
  FiberManualRecord,
  AddCircle,
  BarChart,
  KeyboardArrowDown,
  KeyboardArrowUp,
  GetApp,
  Chat,
  ArrowBack,
  OpenInBrowser,
} from "@material-ui/icons";
import FormularioTarea from "./Components/FormularioTarea";
import FormularioSeguimiento from "./Components/FormularioSeguimiento";
import FormularioIntegrante from "./Components/FormularioIntegrante";
import FormularioIncidencia from "./Components/FormularioIncidencia";
import FormularioCerrar from "./Components/FormularioCerrarTarea";
import CardT from "./Components/CardTarea";
import CardS from "./Components/CardSeguimiento";
import InformacionSol from "./Components/InformacionSolicitud";
import DetalleTarea from "./Components/DetalleTarea";
import Detalleseg_inci from "./Components/Detalleseg_inci";
import { useLocation } from "react-router-dom";
import MenuOpciones from "./Components/MenuOpciones";
import { useNavigate } from "react-router-dom";
import { orange } from "@material-ui/core/colors";
import HeaderSelects from "general/HeaderSelects";
import Observaciones from "./Components/Observaciones/Observaciones";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  bold: {
    fontWeight: 600,
  },
  redAvatar: {
    color: red[500],
  },
  greyAvatar: {
    color: theme.palette.grey[500],
  },
  blueAvatar: {
    color: "#087AC1",
  },
  orangeAvatar: {
    color: orange[500],
  },
}));

//ya no lo borrres plox
const Panel = ({ permisos, usuario }) => {
  const classes = useStyles();
  const { state } = useLocation();
  const [data, setData] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(true);
  const [mensaje, setMensaje] = useState({ open: false });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });
  const [comAdvertencia, setComAdvertencia] = useState({
    open: false,
    titulo: "",
  });
  const [mAdvertenciaP, setMAdvertenciaP] = useState({
    open: false,
    titulo: "",
  });
  const [ctl, setCtl] = useState({
    tareas: [],
    tareasA: [],
    tareasT: [],
    infosol: {},
    nhorasactual: 0,
    nhorastotales: 0,
    nhoras_actuales: {},
    tareas_by_user: {},
    getSol: [],
    infoarchivos: [],
    tipoSeguimiento: [],
    integrantes:[],
  });
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const fechaActual = year + "-" + month + "-" + day;

  const [modal, setModal] = useState({
    open: false,
    titulo: "",
    item: [],
    t: "",
    index: "",
    cerrarT: false,
    props: null
  });
  const {
    register,
    unregister,
    errors,
    handleSubmit,
    watch,
    setValue,
    getValues,
    setCambio,
    control,
  } = useForm();
  const [anchorEl, setAnchorEl] = useState({ current: null });

  // VARIABLES PARA CARDS DE TAREAS E INCIDENCIAS
  const [disabled_S, setDisabled_S] = useState(false);
  const [disabled_A, setDisabled_A] = useState(false);
  const [disabled_T, setDisabled_T] = useState(false);
  const [disabled_segInc, setDisabled_segInc] = useState(false);
  const [limites, setLimites] = useState({
    limite: 8,
    limiteA: 8,
    limiteT: 8,
    limiteSeg: 4,
    limiteI: 4,
  });
  const [btndisabled, setBtndisabled] = useState(false);
  /// FIN DECLARACION
  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const cerrarAdvertencia = () =>
    setMAdvertencia({ ...mAdvertencia, open: false });
  const cerrarAdvertenciaP = () =>
    setMAdvertenciaP({ ...mAdvertenciaP, open: false });
  const cerrarComAdvertencia = () =>
    setComAdvertencia({ ...comAdvertencia, open: false });

  const abrirAdvertencia = (titulo = "", tipo = "") => (dataForm) => {
    if (titulo == "TAREA" && tipo == "inserTarea")
      // CREAR TAREA
      serviciosSolicitudes.getHrsHombre(
        (data) => {
          if (data.sobrepasa) {
            let msj =
              "Los miembros del equipo tendrían las siguientes horas asignadas por semana.";
            let semana = "";
            data.arrSobrepasa
              .filter((value) => value.horas >= 45)
              .map((element) => {
                if (semana != element.nsemana) {
                  msj += " SEMANA  " + element.nsemana + " : ";
                  semana = element.nsemana;
                }
                msj +=
                  element.nombre + " - " + element.horas.toFixed(2) + " hrs, ";
              });
            msj = msj.substring(0, msj.length - 2);

            setMAdvertencia({
              open: true,
              titulo: "ADVERTENCIA",
              mensaje: msj,
              aceptar: (event) => modal.guardar({ ...dataForm, id: modal.id }),
              //aceptar(data),
            });
          } else {
            modal.guardar({ ...dataForm, id: modal.id });
          }
        },
        setCargando,
        { ...dataForm }
      );
    else if (titulo == "TAREA" && tipo == "updateTarea")
      // Edicion de tarea
      serviciosSolicitudes.getHrsHombreUpd(
        (data) => {
          if (
            data.existenResponsables == false &&
            data.arrayResponsables == true &&
            data.sobrepasa
          ) {
            let msj =
              "Los miembros del equipo tendrían las siguientes horas asignadas por semana.";
            let semana = "";
            data.arrSobrepasa
              .filter((value) => value.horas >= 45)
              .map((element) => {
                if (semana != element.nsemana) {
                  msj += " SEMANA  " + element.nsemana + " : ";
                  semana = element.nsemana;
                }
                msj +=
                  element.nombre + " - " + element.horas.toFixed(2) + " hrs, ";
              });
            msj = msj.substring(0, msj.length - 2);

            setMAdvertencia({
              open: true,
              titulo: "ADVERTENCIA",
              mensaje: msj,
              aceptar: (event) => modal.guardar({ ...dataForm, id: modal.id }),
              //aceptar(data),
            });
          } else {
            modal.guardar({ ...dataForm, id: modal.id });
          }
        },
        setCargando,
        { ...dataForm, id: modal.id }
      );
    else
      setMAdvertencia({
        open: true,
        titulo: "ADVERTENCIA",
        mensaje:
          "Asegúrese  de que todos los datos son correctos antes de continuar con esta acción.",
        aceptar: (event) => modal.guardar({ ...dataForm, id: modal.id }),
      });
  };

  const abrirAdvertencia2 = (titulo = "", tipo = "") => (dataForm) => {
    if (titulo == "TAREA" && tipo == "inserTarea")
      serviciosSolicitudes.getHrsHombre(
        (data) => {
          if (data.sobrepasa) {
            let msj =
              "Los miembros del equipo tendrían las siguientes horas asignadas por semana.";
            let semana = "";
            data.arrSobrepasa
              .filter((value) => value.horas >= 45)
              .map((element) => {
                if (semana != element.nsemana) {
                  msj += " SEMANA  " + element.nsemana + " : ";
                  semana = element.nsemana;
                }
                msj +=
                  element.nombre + " - " + element.horas.toFixed(2) + " hrs, ";
              });
            msj = msj.substring(0, msj.length - 2);

            setMAdvertencia({
              open: true,
              titulo: "ADVERTENCIA",
              mensaje: msj,
              aceptar: (event) =>
                modal.guardar({ ...dataForm, id: modal.id, cerrarT: true }),
            });
          } else {
            modal.guardar({ ...dataForm, id: modal.id, cerrarT: true });
          }
        },
        setCargando,
        { ...dataForm }
      );
  };

  const handleExpandClick = () => setExpanded(!expanded);
  const handleExpandClick1 = () => setExpanded1(!expanded1);
  const handleExpandClick2 = () => setExpanded2(!expanded2);
  const handleExpandClick3 = () => setExpanded3(!expanded3);
  const navigate = useNavigate();
  const clickGrafica = () =>
    navigate("/Panelsol", { state: { idsolicitud: state.id } });
  const clickRegresar = () => {
    if (state.pag == "malcance")
      navigate("/ModAlcance", { state: { id: state.id } });
    else navigate("/", { state: { idsolicitud: state.id } });
  };

  const respuesta = (onSuccess) => (status, mensaje, datos) => {
    if (status > 0) {
      onSuccess();
      if (datos?.nhoras_actuales)
        setCtl({
          ...ctl,
          ...datos,
          nhorasactual: datos.nhoras_actuales[0].sumatoria_tareas
            ? datos.nhoras_actuales[0].sumatoria_tareas
            : 0,
        });
      else setCtl({ ...ctl, ...datos });

      setMensaje({ open: true, status: status, value: mensaje });
      cerrarAdvertencia();
      cerrarModal();
    } else {
      setMensaje({ open: true, status: status, value: mensaje });
      cerrarAdvertencia();
    }
  };
  const respuestaReturn = (onSuccess) => (status, mensaje, datos) => {
    if (status > 0) {
      onSuccess();
    }
    setMensaje({ open: true, status: status, value: mensaje });
    cerrarAdvertencia();
    clickRegresar();
  };
  const abrirMenu = (row) => (event) =>
    setAnchorEl({ current: event.currentTarget, row: row, tipo: 1 });
  const cerrarModal = () => {
    setModal({ open: false, cerrarT: false });
    setBtndisabled(false);
  };
  const cerrarMenu = () => setAnchorEl({ ...anchorEl, current: null });

  const servicios = {
    get: () => {
      serviciosSolicitudes.tareasAll(
        (data) => {
          setCtl({
            ...ctl,
            tareas: data.tareas,
            tareasA: data.tareasA,
            tareasT: data.tareasT,
            prioridad: data.prioridad,
            personas: data.personas,
            todasTareas: data.todasTareas,
            infosol: data.infoSol,
            infosolMalcance: data.infosolMalcance,
            seguimientos: data.seguimientos,
            incidencias: data.incidencias,
            nhoras_actuales: data.nhoras_actuales,
            nhorasactual: data.nhoras_actuales[0].sumatoria_tareas
              ? data.nhoras_actuales[0].sumatoria_tareas
              : 0,
            malcance: data.malcance,
            tareas_by_user: data.tareas_by_user,
            tareasTodas: data.tareasTodas, // data.tareas.concat(data.tareasA).concat(data.tareasT),
            infoarchivos: data.infoarchivos,
            tipoSeguimiento: data.tipoSeguimiento,
            integrantes: data.integrantes,
          });
        },
        setCargando,
        { idsolicitud: state?.id || 1 }
      );
    },

    update: (data) =>
      serviciosSolicitudes.tareasUpdate(
        respuesta(cerrarModal),
        setCargando,
        data
      ),
    baja: (data) =>
      serviciosCatalogo.personasDown(
        respuesta(() => {}),
        setCargando,
        data
      ),
  };

  const clickEditar = (item) => {
    serviciosSolicitudes.tareasResponsables(
      (respuesta) =>
        setModal({
          open: true,
          item: {
            ...item,
            responsables: respuesta.responsables,
            infotarea: respuesta.infotarea,
          },
          id: item.idtarea,
          index: item.contador,
          Formulario: FormularioTarea,
          guardar: updateTarea,
          tipo: "updateTarea",
          t: "update",
          titulo: "TAREA",
        }),
      setCargando,
      { idtarea: item.idtarea }
    );
  };
  const clickCerrarT = (item) => {
    serviciosSolicitudes.tareasResponsables(
      (respuesta) =>
        setModal({
          open: true,
          item: {
            ...item,
            responsables: respuesta.responsables,
            infotarea: respuesta.infotarea,
          },
          id: item.idtarea,
          Formulario: FormularioCerrar,
          guardar: updateTareaCerrar,
          tipo: "cerrarTarea",
          t: "update",
          titulo: "TAREA",
        }),
      setCargando,
      { idtarea: item.idtarea }
    );
  };

  const clickDetalleTarea = (item) => {
    setMAdvertencia({
      open: true,
      titulo: "DETALLE DE TAREA",
      mensaje: (
        <React.Fragment>
          <DetalleTarea
            register={register}
            ctl={item}
            setValue={setValue}
            watch={watch}
            errors={getErrorMessage(errors)}
            defaultItem={modal.item || {}}
          />
        </React.Fragment>
      ),
    });
  };
  const clickDetalleSeguimiento = (item) => {
    serviciosSolicitudes.PersonasSeguimiento(
      (respuesta) =>
        setMAdvertenciaP({
          open: true,
          info: {
            ...item,
            personas: respuesta.personas,
          },
          tipo: "seguimiento",
          titulo: "DETALLE DE SEGUIMIENTO",
          mensaje: (
            <React.Fragment>
              <Detalleseg_inci
                register={register}
                ctl={item}
                personas={respuesta.personas}
                tipo={"seguimiento"}
                setValue={setValue}
                watch={watch}
                errors={getErrorMessage(errors)}
                defaultItem={modal.item || {}}
              />
            </React.Fragment>
          ),
        }),
      setCargando,
      { idseguimiento: item.idseguimiento }
    );
  };
  const clickDetalleIncidencia = (item) => {
    serviciosSolicitudes.PersonasSeguimiento(
      (respuesta) =>
        setMAdvertenciaP({
          open: true,
          info: {
            ...item,
            personas: respuesta.personas,
          },
          titulo: "DETALLE DE INCIDENCIA",
          tipo: "incidencia",
          mensaje: (
            <React.Fragment>
              <Detalleseg_inci
                register={register}
                ctl={item}
                personas={respuesta.personas}
                tipo={"incidencia"}
                setValue={setValue}
                watch={watch}
                errors={getErrorMessage(errors)}
                defaultItem={modal.item || {}}
              />
            </React.Fragment>
          ),
        }),
      setCargando,
      { idincidencia: item.idincidencia }
    );
  };
  const clickEditarSe = (item) => {
    serviciosSolicitudes.seguimientosResponsables(
      (respuesta) =>
        setModal({
          open: true,
          item: {
            ...item,
            responsables: respuesta.responsables,
          },
          id: item.idseguimiento,
          index: item.contador,
          Formulario: FormularioSeguimiento,
          guardar: updateSeguimiento,
          tipo: "updateSeguimiento",
          t: "update",
          titulo: "SEGUIMIENTO",
        }),
      setCargando,
      { idseguimiento: item.idseguimiento }
    );
  };
  const clickEditarInci = (item) => {
    serviciosSolicitudes.incidenciasResponsables(
      (respuesta) =>
        setModal({
          open: true,
          item: {
            ...item,
            responsables: respuesta.responsables,
          },
          id: item.idincidencia,
          index: item.contador,
          Formulario: FormularioIncidencia,
          guardar: updateIncidencia,
          tipo: "updateIncidencia",
          t: "update",
          titulo: "INCIDENCIA",
        }),
      setCargando,
      { idincidencia: item.idincidencia, idsolicitud: state.id }
    );
  };

  const clickNuevo = () => {
    serviciosSolicitudes.tareasHoras(
      (respuesta) => {
        setCtl({
          ...ctl,
          nhorasactual: respuesta[0].sumatoria_tareas
            ? respuesta[0].sumatoria_tareas
            : 0,
        });
        setModal({
          open: true,
          Formulario: FormularioTarea,
          guardar: guardarTarea,
          tipo: "inserTarea",
          titulo: "TAREA",
          t: "insert",
          cerrarT: true,
        });
      },
      setCargando,
      { idsolicitud: state.id }
    );
  };

  const clickNuevoSeguimiento = () =>
    setModal({
      open: true,
      Formulario: FormularioSeguimiento,
      guardar: guardarSeguimiento,
      tipo: "insertSeg",
      titulo: "SEGUIMIENTO",
      t: "insert",
      cerrarT: false,
    });

  const clickNuevaIncidencia = () =>
    setModal({
      open: true,
      Formulario: FormularioIncidencia,
      guardar: guardarIncidencia,
      tipo: "insertIncidencia",
      titulo: "INCIDENCIA",
      t: "insert",
      cerrarT: false,
    });
  const clickNuevoIntegrante = () =>{
    setModal({
      open: true,
      Formulario: FormularioIntegrante,
      guardar: guardarIntegrante,
      tipo: "insertIncidencia",
      titulo: "INTEGRANTE",
      t: "insert",
      cerrarT: false,
      props: { state}

    });

  }
  const guardarTarea = (data) => {
    if (!!!ctl.tareasTodas.find((element) => element.titulo == data.titulo)) {
      setBtndisabled(true);
      setDisabled_A(false);
      setDisabled_S(false);

      serviciosSolicitudes.tareasCreate(respuesta(cerrarModal), setCargando, {
        ...data,
        incidencia: permisos?.crear_tar_inc ? 1 : 0,
        prop_nhoras_tarea: permisos?.crear_tar_inc ? 0 : data.prop_nhoras_tarea,
        limiteA: limites.limiteA,
        limite: limites.limite,
        cerrarT: data.cerrarT ? data.cerrarT : false,
      });
    } else {
      cerrarAdvertencia();
      setMensaje({
        open: true,
        status: 0,
        value: "Ya existe una tarea con este título",
      });
    }
  };

  const updateTarea = (data) => {
    setDisabled_A(false);
    setDisabled_S(false);
    serviciosSolicitudes.tareasUpdate(respuesta(cerrarModal), setCargando, {
      ...data,
      limiteA: limites.limiteA,
      limite: limites.limite,
    });
  };
  const updateTareaCerrar = (data) => {
    setDisabled_A(false);
    setDisabled_T(false);
    serviciosSolicitudes.cerrartareasUpdate(
      respuesta(cerrarModal),
      setCargando,
      { ...data, limiteA: limites.limiteA, limiteT: limites.limiteT }
    );
  };
  const updateSeguimiento = (data) => {
    setDisabled_segInc(false);
    serviciosSolicitudes.seguimientoUpdate(
      respuesta(cerrarModal),
      setCargando,
      { ...data, limiteSeg: limites.limiteSeg }
    );
  };
  const updateIncidencia = (data) => {
    setDisabled_segInc(false);
    serviciosSolicitudes.incidenciaUpdate(respuesta(cerrarModal), setCargando, {
      ...data,
      limiteI: limites.limiteI,
    });
  };
  const guardarSeguimiento = (data) => {
    setDisabled_segInc(false);
    serviciosSolicitudes.seguimientosCreate(
      respuesta(cerrarModal),
      setCargando,
      { ...data, limiteSeg: limites.limiteSeg }
    );
  };
  const guardarIncidencia = (data) => {
    setDisabled_segInc(false);
    serviciosSolicitudes.incidenciaCreate(respuesta(cerrarModal), setCargando, {
      ...data,
      limiteI: limites.limiteI,
    });
  };
  const guardarIntegrante= (data) => {
    setDisabled_segInc(false);
    serviciosSolicitudes.integrantesCreate((status, mensaje, datos) => {
      if (status > 0) {
        setCtl({
          ...ctl,
          integrantes: datos.integrantes,
          personas: datos.personas,
        });

      }
      setMensaje({ open: true, status: status, value: mensaje });
      cerrarAdvertencia();
      cerrarModal();
    }, setCargando, {
      ...data,
      idsolicitud: state.id,
      limiteI: limites.limiteI,
    });
  };

  const clickComentarios = () => {
    serviciosSolicitudes.getAllcomentarios(
      (respuesta) =>
        setComAdvertencia({
          open: true,
          titulo: "HISTORIAL",
          width: "sm",
          Formulario: Observaciones,
          item: respuesta.observaciones,
          // guardar: guardarComentario,
        }),
      // register('persona', {required:{ value: true, message: 'Campo requerido'} });
      setCargando,
      { idsolicitud: state.id }
    );
  };

  const guardarComentario = (data) => {
    serviciosSolicitudes.inserComentario(respuesta(cerrarModal), setCargando, {
      comentario: data,
      idsolicitud: state.id,
    });
  };

  const enviarTester = () => {
    var title = "ENVIAR A PRUEBAS DE TESTER";
    var mnsj =
      "Si tiene modificaciones de alcance en desarrollo estas también serán enviadas a pruebas de tester. ¿Está seguro de enviar a pruebas de tester la solicitud #" +
      state.id +
      " ?";
    var cambio = 15;
    var accion = "ptester";

    var propModal = {
      titulo: title,
      mensaje: mnsj,
    };

    setMAdvertencia({
      open: true,
      edicionEspecial: false,
      width: "sm",
      paddingDisabled: false,
      aceptar: () =>
        serviciosSolicitudes.cambioEstatus(
          respuestaReturn(cerrarAdvertencia),
          setCargando,
          {
            idsolicitud: state.id,
            idpropuesta: ctl.infosol.idpropuesta,
            estatus: cambio,
            tipo: accion,
            estatusSelect: -1,
          }
        ),
      ...propModal,
    });
  };

  const descargarDocsReq = () => {
    serviciosSolicitudes.getDocumentosReq(
      (data) => {
        if (data.infoarchivosReq.length > 0) {
          data.infoarchivosReq.forEach((element, i) => {
            (function(index) {
              setTimeout(function() {
                const link = document.createElement("a");
                link.href =
                  "https://dashboard.gphsis.com/back/Login/obtenerArchivoReq/" +
                  element.idarchivoreq +
                  "/solicitud";
                // link.href = "http://localhost/dashboardback/Login/obtenerArchivoReq/" + element.idarchivoreq + "/solicitud";
                link.download = "filename";
                link.click();
                if (data.infoarchivosReq.length - 1 == i)
                  setTimeout(function() {
                    setCargando(false);
                  }, 4000);
              }, (i + 1) * 3000);
            })(i);
          });
        } else {
          console.log("NO SE ENCONTRÓ ARCHIVO DE REQUERIMIENTOS");
          setMensaje({
            open: true,
            status: 0,
            value: "No se encontró archivo de requerimientos",
          });
        }
      },
      setCargando,
      { idsolicitud: state.id }
    );
  };

  const accionesFila = [
    {
      label: "TAREA",
      onClick: clickNuevo,
      enabled: permisos?.crear_tarea || permisos?.crear_tar_inc,
    },
    {
      label: "SEGUIMIENTO",
      onClick: clickNuevoSeguimiento,
      enabled: permisos?.crear_inc_seg,
    },
    {
      label: "INCIDENCIA",
      onClick: clickNuevaIncidencia,
      enabled: permisos?.crear_inc_seg,
    },
    {
      label: "INTEGRANTE",
      onClick: clickNuevoIntegrante,
      enabled: permisos?.crear_inc_seg,
    },
  ];
  const accionesFilaGrafica = [
    { label: "GRÁFICA", onClick: clickGrafica, enabled: true },
  ];

  const clickPropuesta = (item) => {
    let propModal = {
      titulo: "Generar propuesta de líder",
      tipo: 0,
    };

    setMAdvertencia({
      open: true,
      item,
      edicionEspecial: false,
      width: "lg",
      paddingDisabled: true,
      Formulario: Propuesta,
      guardar: guardarPropuesta,
      ...propModal,
    });
  };
  const clickSolicitudes = (respuesta) => {
    console.log("llego");
  };

  const guardarPropuesta = (data) => {};

  useEffect(() => {
    servicios.get(setData, setCargando);
  }, []);

  useEffect(() => {
    if (modal.open && modal.tipo) {
      if (modal.tipo == "inserTarea" || modal.tipo == "updateTarea") {
        register("prioridad", {
          required: { value: true, message: "CAMPO REQUERIDO" },
        });
        register("titulo", {
          required: { value: true, message: "CAMPO REQUERIDO" },
        });
        if (!permisos?.crear_tar_inc) {
          if (ctl.malcance.length > 0)
            register("malcance", {
              required: { value: true, message: "CAMPO REQUERIDO" },
            });
          else register("malcance");

          register("prop_inicio", {
            required: { value: true, message: "F. INICIO ES REQUERIDA" },
            minLength: { value: 1, message: "MÍNIMO 1 CARÁCTERES" },
          });
          register("prop_fin", {
            required: { value: true, message: "F. FIN ES REQUERIDA" },
            minLength: { value: 1, message: "MÍNIMO 1 CARÁCTERES" },
          });
        }
      } else if (
        modal.tipo == "insertSeg" ||
        modal.tipo == "updateSeguimiento"
      ) {
        register("tipoSeguimiento", {
          required: { value: true, message: "Campo requerido" },
        });
        register("fecha_inicio", {
          required: { value: true, message: "F. INICIO ES REQUERIDA" },
          minLength: { value: 1, message: "MÍNIMO 1 CARÁCTERES" },
        });
        register("fecha_termino", {
          required: { value: true, message: "F. FIN ES REQUERIDA" },
          minLength: { value: 1, message: "MÍNIMO 1 CARÁCTERES" },
        });
      } else if (
        modal.tipo == "insertIncidencia" ||
        modal.tipo == "updateIncidencia"
      ) {
        register("fecha_inicio", {
          required: { value: true, message: "F. INICIO ES REQUERIDA" },
          minLength: { value: 1, message: "MÍNIMO 1 CARÁCTERES" },
        });
        register("fecha_termino", {
          required: { value: true, message: "F. FIN ES REQUERIDA" },
          minLength: { value: 1, message: "MÍNIMO 1 CARÁCTERES" },
        });
        register("prioridad");
        register("tareas");
      }
    }
  }, [modal]);

  useEffect(() => {
    if (modal.tipo == "inserTarea" || modal.tipo == "updateTarea") {
      //Tareas
      if (modal.open && modal.item) {
        //SI se está editando
        setValue(
          //prioridad
          "prioridad",
          modal.item.idprioridad
            ? {
                idprioridad: modal.item.idprioridad,
                nprioridad: modal.item.nprioridad,
              }
            : null
        );
        if (!permisos?.crear_tar_inc) {
          setValue(
            "prop_inicio",
            modal.item.fecha_inicio
              ? modal.item.fecha_inicio
              : modal.item.prop_inicio
              ? modal.item.prop_inicio
              : fechaActual
          );
          setValue(
            "prop_fin",
            modal.item.fecha_termino
              ? modal.item.fecha_termino
              : modal.item.prop_fin
              ? modal.item.prop_fin
              : fechaActual
          );

          if (modal.item?.responsables || modal.item.responsables.length > 0) {
          }
          if (modal.item.idmalcance != null) {
            // if (modal.item?.idmalcance || modal.item.idmalcance.length > 0) {
            setValue("malcance", {
              idmalcance: modal.item.idmalcance,
              titulo: modal.item.infotarea["titulo"],
            });
          } else {
            setValue("malcance", null);
          }
        }
      } else {
        //es un insert
        setValue("prioridad", null);
        if (!permisos?.crear_tar_inc) {
          setValue("malcance", null);
          setValue("prop_fin", fechaActual);
        }
      }
    } else if (
      modal.tipo == "insertSeg" ||
      modal.tipo == "updateSeguimiento" ||
      modal.tipo == "insertIncidencia" ||
      modal.tipo == "updateIncidencia"
    ) {
      //Seguimientos  e incidencias
      if (modal.open && modal.item) {
        //SI se está editando
        if (modal.item?.responsables || modal.item.responsables.length > 0) {
          console.log("esta aca en seguimieno");
        }
        if (modal.item.idtarea && modal.item.idtarea != null) {
          setValue("tareas", {
            idtarea: modal.item.idtarea,
            titulo: modal.item.tituloTarea,
          });
        } else {
          setValue("tareas", null);
        }

        setValue("fecha_inicio", modal.item.fecha_inicio);
        setValue("fecha_termino", modal.item.fecha_termino);
      } else {
        setValue("fecha_inicio", fechaActual);
        setValue("fecha_termino", fechaActual);
      }
    } else {
      // console.log('estamos en un');
      unregister("prioridad");
      unregister("tareas");
      // unregister("malcance");
      // setValue("prioridad", null);
    }
  }, [modal]);

  const descargarDocs = () => {
    setCargando(true);
    ctl.infoarchivos.forEach((element, i) => {
      //for (var i = 1; i <= ctl.infoarchivos.length; i++) {
      (function(index) {
        setTimeout(function() {
          const link = document.createElement("a");
          link.href =
            "https://dashboard.gphsis.com/back/Login/whatever/" +
            element.idarchivo;
          // link.href = "http://localhost/dashboardback/Login/whatever/"+element.idarchivo;
          link.download = "filename";
          link.click();
          if (ctl.infoarchivos.length - 1 == i)
            setTimeout(function() {
              setCargando(false);
            }, 4000);
        }, (i + 1) * 3000);
      })(i);
    });
  };
  const mostrarErrorFormulario = (error) => {
    if (error.responsables)
      setMensaje({ open: true, status: -1, value: error.responsables.message });
  };
  const pageInfiniteScroll = () => {
    const page_limit = 8;
    let pageNo = ctl.tareas.length / page_limit + 1;
    let total_datos = pageNo * page_limit;
    setLimites({ ...limites, limite: total_datos });
    serviciosSolicitudes.getTarea_S(
      (data) => {
        if (ctl.tareas.length == data.length) setDisabled_S(true);

        setCtl({ ...ctl, tareas: [...data] });
      },
      setCargando,
      { idsolicitud: state?.id || 1, limite: total_datos }
    );
  };
  const pageInfiniteScroll_tareasA = () => {
    const page_limit = 8;
    let pageNo = ctl.tareasA.length / page_limit + 1;
    let total_datos = pageNo * page_limit;
    setLimites({ ...limites, limiteA: total_datos });
    serviciosSolicitudes.getTarea_A(
      (data) => {
        if (ctl.tareasA.length == data.length) setDisabled_A(true);

        setCtl({ ...ctl, tareasA: [...data] });
      },
      setCargando,
      { idsolicitud: state?.id || 1, limiteA: total_datos }
    );
    // setCtlTareasA(ctl.tareasA.slice(0, total_datos));
  };
  const pageInfiniteScroll_tareasT = () => {
    const page_limit = 8;
    let pageNo = ctl.tareasT.length / page_limit + 1;
    let total_datos = pageNo * page_limit;
    setLimites({ ...limites, limiteT: total_datos });
    serviciosSolicitudes.getTarea_T(
      (data) => {
        if (ctl.tareasT.length == data.length) setDisabled_T(true);

        setCtl({ ...ctl, tareasT: [...data] });
      },
      setCargando,
      { idsolicitud: state?.id || 1, limiteT: total_datos }
    );
    // setCtlTareasT(ctl.tareasT.slice(0, total_datos));
  };

  const pageInfiniteScroll_segInc = () => {
    const page_limit = 8;
    let pageNo =
      (ctl.seguimientos.length + ctl.incidencias.length) / page_limit + 1;
    let total_datos = pageNo * page_limit;
    setLimites({
      ...limites,
      limiteI: total_datos / 2,
      limiteSeg: total_datos / 2,
    });
    serviciosSolicitudes.getSegInc(
      (data) => {
        if (
          ctl.seguimientos.length + ctl.incidencias.length ==
          data.seguimientos.length + data.incidencias.length
        )
          setDisabled_segInc(true);

        setCtl({
          ...ctl,
          seguimientos: [...data.seguimientos],
          incidencias: [...data.incidencias],
        });
      },
      setCargando,
      {
        idsolicitud: state?.id || 1,
        limiteSeg: total_datos / 2,
        limiteI: total_datos / 2,
      }
    );
    // setCtlTareasT(ctl.tareasT.slice(0, total_datos));
  };
  return (
    <Page
      className={classes.root}
      title="GESTIONAR SOLICITUD"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <HeaderSelects
          title="GESTIONAR SOLICITUD"
          subtitle={
            ctl.infosol
              ? "#" + ctl.infosol.idsolicitud + " " + ctl.infosol.titulo
              : ""
          }
          clickSolicitudes={clickSolicitudes}
          bandera={1}
          id={state.id}
          register={register}
          handleSubmit={handleSubmit}
          setCtl={setCtl}
          ctl={ctl}
          getValues={getValues}
          setCambio={setCambio}
          setCargando={setCargando}
          setValue={setValue}
          watch={watch}
          errors={getErrorMessage(errors)}
        />
        <Grid container spacing={3}>
          <Grid item xs={3} style={{ height: 600 }}>
            <Scrollbars style={{ flex: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="SOLICITUD"
                      action={
                        <React.Fragment>
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleExpandClick}
                          >
                            {expanded ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </React.Fragment>
                      }
                    />
                    <Divider />
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                      <CardContent>
                        <InformacionSol
                          register={register}
                          ctl={ctl}
                          setValue={setValue}
                          watch={watch}
                          errors={getErrorMessage(errors)}
                          defaultItem={modal.item || {}}
                        />
                      </CardContent>
                    </Collapse>
                    {/* <Divider /> */}
                    <CardActions>
                      <React.Fragment>
                        {permisos && permisos?.agregar && (
                          <Tooltip title="AGREGAR">
                            <IconButton
                              aria-label="more"
                              aria-controls="long-menu"
                              aria-haspopup="true"
                              onClick={abrirMenu(data)}
                            >
                              <AddCircle />
                            </IconButton>
                          </Tooltip>
                        )}
                        {permisos && permisos?.indicadores && (
                          <Tooltip title="GRÁFICA">
                            <IconButton
                              aria-label="more"
                              aria-controls="long-menu"
                              aria-haspopup="true"
                              onClick={clickGrafica}
                            >
                              <BarChart />
                            </IconButton>
                          </Tooltip>
                        )}
                        {ctl.infoarchivos.length > 0 && (
                          <Tooltip title="DESCARGAR ARCHIVOS">
                            <IconButton
                              type="button"
                              title="descargar archivos"
                              size="small"
                              onClick={descargarDocs}
                              aria-label="descargar"
                            >
                              <GetApp />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title="HISTORIAL">
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={clickComentarios}
                          >
                            <Chat />
                          </IconButton>
                        </Tooltip>
                        <Menu
                          anchorEl={anchorEl.current}
                          keepMounted
                          open={Boolean(anchorEl.current)}
                          onClose={cerrarMenu}
                        >
                          <MenuOpciones
                            accionesFila={
                              // anchorEl.tipo && anchorEl.tipo == 1
                              //   ? accionesFila : accionesFila
                              accionesFila
                            }
                            cerrarMenu={cerrarMenu}
                            anchorEl={anchorEl}
                          />
                        </Menu>
                        {/* <Button variant="text" onClick={clickRegresar}>
                          REGRESAR
                        </Button> */}
                        {ctl.infosol.idestatus == 4 &&
                          ctl.tareasT.length > 0 &&
                          ctl.tareas.length == 0 &&
                          ctl.tareasA.length == 0 &&
                          usuario[0].idrol == 2 && (
                            <Tooltip title="ENVIAR A PRUEBAS DE TESTER">
                              <IconButton
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true"
                                onClick={enviarTester}
                              >
                                <OpenInBrowser />
                              </IconButton>
                            </Tooltip>
                          )}
                        <Tooltip title="REGRESAR">
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={clickRegresar}
                          >
                            <ArrowBack />
                          </IconButton>
                        </Tooltip>
                      </React.Fragment>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="MIEMBROS DEL EQUIPO"
                      action={
                        <React.Fragment>
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleExpandClick1}
                          >
                            {expanded1 ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </React.Fragment>
                      }
                    />
                    <Divider />
                    <Collapse in={expanded1} timeout="auto" unmountOnExit>
                      <CardContent>
                        {ctl.personas
                          ? ctl.personas.map((persona, index) =>
                              index == 0 ? (
                                <React.Fragment>
                                  <Typography
                                    variant="caption"
                                    className={classes.bold}
                                  >
                                    {"LÍDER: "}
                                  </Typography>
                                  <Typography variant="caption">
                                    {persona.nombre}
                                  </Typography>
                                  <Divider />
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  <Typography variant="caption">
                                    {persona.nombre}
                                  </Typography>
                                  <Divider />
                                </React.Fragment>
                              )
                            )
                          : "N/D"}
                      </CardContent>
                    </Collapse>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="TAREAS A DESARROLLAR"
                      action={
                        <React.Fragment>
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleExpandClick2}
                          >
                            {expanded2 ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </React.Fragment>
                      }
                    />
                    <Divider />
                    <Collapse in={expanded2} timeout="auto" unmountOnExit>
                      <CardContent>
                        {ctl.infosol ? (
                          <Typography variant="caption">
                            {ctl.infosol.comentario}
                          </Typography>
                        ) : (
                          "N/D"
                        )}
                      </CardContent>
                    </Collapse>
                    <CardActions>
                      <React.Fragment>
                        <Tooltip title="REQUERIMIENTOS">
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={descargarDocsReq}
                          >
                            <GetApp />
                          </IconButton>
                        </Tooltip>
                      </React.Fragment>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="NOMENCLATURA DE COLORES"
                      action={
                        <React.Fragment>
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleExpandClick3}
                          >
                            {expanded3 ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </React.Fragment>
                      }
                    />
                    <Divider />
                    <Collapse in={expanded3} timeout="auto" unmountOnExit>
                      <CardContent>
                        {/* <Box> */}
                        {/* <Typography variant="h6" component="div">TAREAS</Typography> */}
                        <Box display="flex">
                          <FiberManualRecord className={classes.redAvatar} />
                          <Typography variant="body2">
                            {" "}
                            TAREAS-PRIORIDAD ALTA
                          </Typography>
                        </Box>
                        <Box display="flex">
                          <FiberManualRecord className={classes.greyAvatar} />
                          <Typography variant="body2">
                            {" "}
                            TAREAS-PRIORIDAD MEDIA Y BAJA
                          </Typography>
                        </Box>
                        {/* </Box>
                      <Box> */}
                        {/* <Box display='flex'><TrendingFlat className={classes.redAvatar}/><Typography variant="h6" component="div">SEGUIMIENTOS</Typography></Box> */}
                        <Box display="flex">
                          <FiberManualRecord className={classes.blueAvatar} />
                          <Typography variant="body2">SEGUIMIENTOS</Typography>
                        </Box>
                        {/* </Box>
                      <Box> */}
                        {/* <Box display='flex'><TrendingFlat className={classes.redAvatar}/><Typography variant="h6" component="div">INCIDENCIAS</Typography></Box> */}
                        <Box display="flex">
                          <FiberManualRecord className={classes.orangeAvatar} />
                          <Typography variant="body2"> INCIDENCIAS</Typography>
                        </Box>
                        {/* </Box> */}
                      </CardContent>
                    </Collapse>
                  </Card>
                </Grid>
              </Grid>
            </Scrollbars>
          </Grid>
          <Grid item xs={9}>
            <Scrollbars style={{ flex: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="TAREAS SIN ASIGNAR"
                    />
                  </Card>
                  <br />
                  <Scrollbars style={{ height: 550 }}>
                    <CardT
                      permisos={permisos}
                      register={register}
                      ctl={ctl.tareas}
                      tareas_by_user={ctl.tareas_by_user}
                      setValue={setValue}
                      clickDetalleTarea={clickDetalleTarea}
                      watch={watch}
                      errors={getErrorMessage(errors)}
                      clickEditar={clickEditar}
                      defaultItem={modal.item || {}}
                    />
                    <br />
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={pageInfiniteScroll}
                      fullWidth
                      disabled={disabled_S}
                    >
                      ver más
                    </Button>
                    <br />
                    <br />
                  </Scrollbars>
                </Grid>
                <Grid item xs={3}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="EN DESARROLLO"
                    />
                  </Card>
                  <br />
                  <Scrollbars style={{ height: 550 }}>
                    <CardT
                      permisos={permisos}
                      register={register}
                      ctl={ctl.tareasA}
                      tareas_by_user={ctl.tareas_by_user}
                      setValue={setValue}
                      watch={watch}
                      clickEditar={clickEditar}
                      clickCerrarT={clickCerrarT}
                      clickDetalleTarea={clickDetalleTarea}
                      errors={getErrorMessage(errors)}
                      defaultItem={modal.item || {}}
                    />
                    <br />
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={pageInfiniteScroll_tareasA}
                      fullWidth
                      disabled={disabled_A}
                    >
                      ver más
                    </Button>
                    <br />
                    <br />
                  </Scrollbars>
                </Grid>
                <Grid item xs={3}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="TAREAS CERRADAS"
                    />
                  </Card>
                  <br />
                  <Scrollbars style={{ height: 550 }}>
                    <CardT
                      permisos={permisos}
                      register={register}
                      ctl={ctl.tareasT}
                      tareas_by_user={ctl.tareas_by_user}
                      setValue={setValue}
                      watch={watch}
                      clickDetalleTarea={clickDetalleTarea}
                      errors={getErrorMessage(errors)}
                      defaultItem={modal.item || {}}
                    />
                    <br />
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={pageInfiniteScroll_tareasT}
                      fullWidth
                      disabled={disabled_T}
                    >
                      ver más
                    </Button>
                    <br />
                    <br />
                  </Scrollbars>
                </Grid>
                <Grid item xs={3}>
                  <Card>
                    <CardHeader
                      style={{ textAlign: "center" }}
                      title="SEGUIMIENTOS"
                    />
                  </Card>
                  <br />
                  <Scrollbars style={{ height: 550 }}>
                    <CardS
                      permisos={permisos}
                      register={register}
                      ctlS={ctl.seguimientos}
                      ctlI={ctl.incidencias}
                      clickDetalleSeguimiento={clickDetalleSeguimiento}
                      clickDetalleIncidencia={clickDetalleIncidencia}
                      clickEditarSe={clickEditarSe}
                      clickEditarInci={clickEditarInci}
                      setValue={setValue}
                      watch={watch}
                      errors={getErrorMessage(errors)}
                      defaultItem={modal.item || {}}
                    />
                    <br />
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={pageInfiniteScroll_segInc}
                      fullWidth
                      disabled={disabled_segInc}
                    >
                      ver más
                    </Button>
                    <br />
                    <br />
                  </Scrollbars>
                </Grid>
              </Grid>
            </Scrollbars>
          </Grid>
        </Grid>
      </Container>

      <ModalFormulario
        open={modal.open}
        titulo={
          (modal.item ? "ACTUALIZAR " + modal.titulo + " # " : "AGREGAR ") +
          " " +
          (modal.index ? modal.index : modal.titulo)
        }
        aceptar={handleSubmit(
          abrirAdvertencia(modal.titulo, modal.tipo),
          mostrarErrorFormulario
        )}
        OnCancelar={cerrarModal}
        bloqueo={btndisabled}
        onCerrarTarea={handleSubmit(
          abrirAdvertencia2(modal.titulo, modal.tipo)
        )}
        cerrarTarea={modal.cerrarT}
      >
        {modal.Formulario && (
          <modal.Formulario
          {...modal.props}
            register={register}
            ctl={ctl}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            control={control}
            setMensaje={setMensaje}
            // guardar={mAdvertencia.guardar}
            errors={getErrorMessage(errors)}
            defaultItem={modal.item || {}}
            id={state.id || {}}
            permisos={permisos}
          />
        )}
      </ModalFormulario>
      <ModalGeneral
        open={mAdvertencia.open}
        titulo={mAdvertencia.titulo}
        ContenidoMensaje={mAdvertencia.mensaje}
        acciones={
          <React.Fragment>
            {mAdvertencia.titulo == "DETALLE DE TAREA" ? (
              <Button className="btnError" onClick={cerrarAdvertencia}>
                Cerrar
              </Button>
            ) : (
              <React.Fragment>
                <Button className="btnError" onClick={cerrarAdvertencia}>
                  Cancelar
                </Button>
                <Button color="primary" onClick={mAdvertencia.aceptar}>
                  ACEPTAR
                </Button>
              </React.Fragment>
            )}
          </React.Fragment>
        }
      />
      <ModalPrint
        open={mAdvertenciaP.open}
        info={mAdvertenciaP.info}
        tipo={mAdvertenciaP.tipo}
        titulo={mAdvertenciaP.titulo}
        OnCerrar={cerrarAdvertenciaP}
        ContenidoMensaje={mAdvertenciaP.mensaje}
        acciones={
          <React.Fragment>
            <Button className="btnError" onClick={cerrarAdvertenciaP}>
              Cerrar
            </Button>
          </React.Fragment>
        }
      />

      <ModalGeneral
        open={comAdvertencia.open}
        titulo={comAdvertencia.titulo}
        paddingDisabled={comAdvertencia.paddingDisabled}
        ContenidoMensaje={comAdvertencia.mensaje}
        OnCerrar={cerrarComAdvertencia}
      >
        {comAdvertencia.Formulario && (
          <comAdvertencia.Formulario
            setMensaje={setMensaje}
            setCargando={setCargando}
            tipo={comAdvertencia.tipo}
            edicionEspecial={comAdvertencia.edicionEspecial}
            permisos={permisos}
            datoS={comAdvertencia.item}
            usuario={usuario}
            id={state.id}
            pag={"panel"}
            guardar={comAdvertencia.guardar}
            servicios={servicios}
            {...comAdvertencia.props}
          />
        )}
      </ModalGeneral>
    </Page>
  );
};

export default memo(Panel);
